<wd-simple-layout label="Bohrpunktliste">
	<div list-element class="left-split">
		<bp-bohrpunkt-list-panel
			[bps]="bps"
			[pointsFilter]="pointsFilter"
			[boundsFilter]="boundsFilter"
			[currentBounds]="currentBounds"
			[activeId]="active"
			(pointSelected)="select($event.event, $event.bp)"
			(pointsDeleted)="initPoints()">
		</bp-bohrpunkt-list-panel>
	</div>
	<div content-element class="content-wrapper" [class.readonly-locked]="isReadonlyLocked">
		@if (transientProjectActive) {
			<!-- Bug 2 „stilles Projekt" (2026-06-11): Resolver hat das Projekt des
			     Punkts nur fuer diese Ansicht geladen — sichtbar machen statt still.
			     Der Projektname wird fuer Datennutzer/Betrachter verschleiert
			     (transientProjectName -> null), Banner erscheint trotzdem. -->
			<div class="alert alert-info transient-project-banner mb-2 d-flex align-items-start gap-2" role="status">
				<i class="bi bi-info-circle frozen-icon"></i>
				<div class="frozen-text">
					@if (transientProjectName; as transientName) {
						Projekt „{{ transientName }}" wurde vorübergehend für diesen Punkt geöffnet
						und wird beim Verlassen der Detail-Ansicht automatisch wieder geschlossen.
					} @else {
						Für diesen Punkt wurde vorübergehend ein Projekt geöffnet, das beim
						Verlassen der Detail-Ansicht automatisch wieder geschlossen wird.
					}
				</div>
				<button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Hinweis schließen"
					title="Hinweis schließen" (click)="transientBannerDismissed = true"></button>
			</div>
		}
		@if (isPointFrozen) {
			<div class="alert alert-secondary frozen-banner mb-2 d-flex align-items-start gap-2" role="status">
				<i class="bi bi-lock frozen-icon"></i>
				<div class="frozen-text">
					<strong>Punkt gesperrt.</strong>
					@if (frozenForeignProject) {
						@if (frozenForeignProjectName; as foreignName) {
							Dieser Punkt ist abgeschlossen und gehört zum Projekt „{{ foreignName }}".
						} @else {
							Dieser Punkt ist abgeschlossen und gehört zu einem anderen Projekt.
						}
					} @else if (!hasActiveProject) {
						Dieser Punkt ist abgeschlossen. Bitte zuerst ein Projekt öffnen, um ihn zur Bearbeitung freizugeben.
					} @else {
						Dieser Punkt ist abgeschlossen und gehört nicht zum aktuell offenen Projekt.
					}
					@if (hasActiveProject && !canFreigebenInBanner) {
						<div class="readonly-hint mt-1">
							<i class="bi bi-arrow-right"></i> In dieses Projekt übernehmen kann nur ein Manager.
						</div>
					}
				</div>
				@if (canFreigebenInBanner) {
					<button type="button" class="btn btn-sm btn-success ms-auto flex-shrink-0 text-nowrap"
						title="Diesen Punkt in dieses Projekt übernehmen — Workflow wird zurückgesetzt; der Punkt wird aus dem bisherigen Projekt entzogen (Manager)"
						(click)="onFreigeben()">
						<i class="bi bi-arrow-repeat"></i><span class="ms-1">In dieses Projekt übernehmen und zur Bearbeitung freigeben</span>
					</button>
				}
			</div>
		} @else if (viewerHint) {
			<div class="alert alert-secondary frozen-banner mb-0 d-flex align-items-center gap-2" role="status">
				<i class="bi bi-eye frozen-icon"></i>
				<div class="frozen-text">{{ viewerHint }}</div>
			</div>
		} @else if (isReadonlyLocked) {
			<div class="alert alert-secondary frozen-banner mb-0 d-flex align-items-center gap-2" role="status">
				<i class="bi bi-lock frozen-icon"></i>
				<div class="frozen-text">
					<strong>Bearbeitung gesperrt:</strong> {{ editBlock?.reason }}
					@if (editBlock?.hint) {
						<div class="readonly-hint mt-1">
							<i class="bi bi-arrow-right"></i> {{ editBlock?.hint }}
						</div>
					}
				</div>
				@if (canFreigebenInBanner) {
					<button type="button" class="btn btn-sm btn-success ms-auto flex-shrink-0 text-nowrap"
						title="Diesen Punkt in dieses Projekt übernehmen — Workflow wird zurückgesetzt; falls der Punkt zu einem anderen Projekt gehört, wird er dort entzogen (Manager)"
						(click)="onFreigeben()">
						<i class="bi bi-arrow-repeat"></i><span class="ms-1">In dieses Projekt übernehmen und zur Bearbeitung freigeben</span>
					</button>
				}
			</div>
		}
		<!-- Die Ansicht bekommt nur den Platz UNTER den Hinweisbalken. Vorher war sie
		     „100 % hoch" unter den Balken, und genau deren Hoehe fehlte unten - das
		     letzte Feld jeder Maske war unerreichbar (Nutzer-Befund 02.10.2026,
		     e2e/flows/maske-unter-hinweisbalken.spec.ts). -->
		<div class="ansicht-bereich">
			<router-outlet></router-outlet>
		</div>
	</div>
</wd-simple-layout>
